import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/webinars/webinar-on-demand-mastering-clinical-performance-studies-under-ivdr")({
  head: () => buildRouteHead("/en/webinars/webinar-on-demand-mastering-clinical-performance-studies-under-ivdr", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/en/webinars/webinar-on-demand-mastering-clinical-performance-studies-under-ivdr-from-strategy-to-delivery", replace: true });
  },
});
